<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M7.99816 0.640626C6.66694 0.641041 5.36075 1.00253 4.21871 1.68659C3.07669 2.37066 2.14159 3.35168 1.51302 4.52517C0.884448 5.69865 0.585945 7.02066 0.649303 8.35038C0.712659 9.6801 1.13551 10.9677 1.8728 12.0761L0.638672 15.3597L4.77131 14.6123C5.76644 15.0986 6.85848 15.3541 7.96606 15.3595C9.07364 15.365 10.1682 15.1205 11.1681 14.644C12.1679 14.1677 13.0475 13.4717 13.7409 12.608C14.4343 11.7445 14.9241 10.7354 15.1732 9.65624C15.4225 8.57706 15.425 7.45554 15.1804 6.37529C14.9358 5.29503 14.4507 4.2839 13.761 3.41727C13.0713 2.55063 12.1948 1.85086 11.197 1.37009C10.1992 0.889322 9.10575 0.639973 7.99816 0.640626Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.42829 5.7145C5.2705 5.7145 5.14258 5.58658 5.14258 5.42878C5.14258 5.27099 5.2705 5.14307 5.42829 5.14307"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.42773 5.7145C5.58553 5.7145 5.71345 5.58658 5.71345 5.42878C5.71345 5.27099 5.58553 5.14307 5.42773 5.14307"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.5709 5.7145C10.4131 5.7145 10.2852 5.58658 10.2852 5.42878C10.2852 5.27099 10.4131 5.14307 10.5709 5.14307"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.5703 5.7145C10.7281 5.7145 10.856 5.58658 10.856 5.42878C10.856 5.27099 10.7281 5.14307 10.5703 5.14307"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 12.5713C10.2091 12.5713 12 10.7804 12 8.57129H4C4 10.7804 5.79086 12.5713 8 12.5713Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
